// extracted by mini-css-extract-plugin
export default {"notification":"YkBgP27aUe"};
    if(module.hot) {
      // 1648554196349
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  